import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import AdminGroupEditCapabilitiesItem from './CapabilitiesItem';

import ErrorBoundary from '../../ErrorBoundary';
import Loading from '../../Loading';

const AdminGroupEditCapabilitiesEdit = ({
  group,
  capabilities,
  capabilitiesLoading,
  handleCapabilitySwitch,
  ...props
}) => {
  const intl = useIntl();

  if (capabilitiesLoading) {
    return (
      <Loading />
    );
  }

  const capabilitySelected = (cap) => group.capabilities.includes(cap);

  const general = capabilities?.general || {};
  const files = capabilities?.files || {};
  const collections = capabilities?.collections || {};

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <p>
          {intl.formatMessage({ defaultMessage: 'Set the Team capabilities (optional).' })}
        </p>
        <div className="group-permissions permissions-lists">
          {Object.keys(general).length > 0 && (
            <ErrorBoundary>
              <h5 className="permissions-title">
                {intl.formatMessage({ defaultMessage: 'General' })}
              </h5>
              <ListGroup flush className="switch-list group-permissions-list general-permissions-list">
                {Object.keys(general).map(c => (
                  <AdminGroupEditCapabilitiesItem
                    key={c}
                    capability={c}
                    capabilityName={general[c]}
                    checked={capabilitySelected(c)}
                    handleCapabilitySwitch={handleCapabilitySwitch}
                  />
                ))}
              </ListGroup>
            </ErrorBoundary>
          )}
          {Object.keys(files).length > 0 && (
            <ErrorBoundary>
              <h5 className="permissions-title">
                {intl.formatMessage({ defaultMessage: 'Files' })}
              </h5>
              <ListGroup flush className="switch-list group-permissions-list files-permissions-list">
                {Object.keys(files).map(c => (
                  <AdminGroupEditCapabilitiesItem
                    key={c}
                    capability={c}
                    capabilityName={files[c]}
                    checked={capabilitySelected(c)}
                    handleCapabilitySwitch={handleCapabilitySwitch}
                  />
                ))}
              </ListGroup>
            </ErrorBoundary>
          )}
          {Object.keys(collections).length > 0 && (
            <ErrorBoundary>
              <h5 className="permissions-title">
                {intl.formatMessage({ defaultMessage: 'Collections' })}
              </h5>
              <ListGroup flush className="switch-list group-permissions-list collections-permissions-list">
                {Object.keys(collections).map(c => (
                  <AdminGroupEditCapabilitiesItem
                    key={c}
                    capability={c}
                    capabilityName={collections[c]}
                    checked={capabilitySelected(c)}
                    handleCapabilitySwitch={handleCapabilitySwitch}
                  />
                ))}
              </ListGroup>
            </ErrorBoundary>
          )}
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Team' })}
      />
    </ErrorBoundary>
  );
};

AdminGroupEditCapabilitiesEdit.propTypes = {
  group: PropTypes.object.isRequired,
  capabilities: PropTypes.object.isRequired,
  capabilitiesLoading: PropTypes.bool.isRequired,
  handleCapabilitySwitch: PropTypes.func.isRequired,
};

export default AdminGroupEditCapabilitiesEdit;
